import donateCommonAppFeesMixin from '@/mixins/donations/donateCommonAppFeesMixin.js'
import { DEFAULT_DONATION_CURRENCY_CODE, donationCurrencyStripeFixedFee } from '@/constants/currencies.js'

export default {
  mixins:[donateCommonAppFeesMixin],
  data() {
    return {
      ValidationErrorMessage: null,
      Donation: null,
      DonationRecurring: false,
      DonationRecurrences: null,
      DonationName: null,
      DonationAmount: 0,
      DonationAppFeeAmount: 2,
      DonationTakeCareOfFees: false,
      DonationGatewayActive: false,
      DonationCompleted: false,
      DonationAnonymousName: false,
      DonationAnonymousAmount: false,
      DonationShowCommentForm: false,
      DonationComment: null,
      DonationFundraiserChild: null,
      StripeCheckoutObject: null
    }
  },
  watch: {
    DonationAmount(newVal) {
      this.DonationAppFeeAmount = this.donationAppFeeAmountProposed(newVal)
    },
    DonationRecurring(newVal) {
      if(newVal === true) {
        this.DonationRecurrences = 0
      }
    }
  },
  computed: {
    donationCurrency() {
      return (this.fundraiserPage?.currency_metadata?.code
        || this.fundraiserPage?.currency
        || this.team?.currency_metadata?.code
        || this.team?.currency
        || this.fundraiser?.currency_metadata?.code
        || this.fundraiser?.currency
        || DEFAULT_DONATION_CURRENCY_CODE).toUpperCase()
    },
    stripeFeePercent() {
      return 0.029
    },
    stripeFeeFixedAmount() {
      return donationCurrencyStripeFixedFee(this.donationCurrency)
    },
    recurrencesAvailable() {
      // get the deadline and calculate the months between now and the deadline, then return an array of options for the user to select from, with 0 being unlimited
      return [0]
      const deadline = this.fundraiser ? new Date(this.fundraiser.deadline) : null
      if(!deadline) {
        return [3,6,12,0]
      }
      const now = new Date()
      const months = (deadline.getFullYear() - now.getFullYear()) * 12 + (deadline.getMonth() - now.getMonth())
      const options = [3,4,6,7,9,12].filter(option => option === 0 || option <= months)
      if(!options.includes(months) && months > 0) {
        options.push(months)
      }
      options.push(0) // unlimited
      return options
    },
    donationTotalAmount() {
      if(!this.DonationAmount) return 0
      return this.donationAmountToCharge + this.DonationAppFeeAmount
    },
    donationStripeFeeOffsetAmount() {
      if(!this.DonationTakeCareOfFees || !this.DonationAmount) {
        return 0
      }

      const subtotal = parseFloat(this.DonationAmount) + this.DonationAppFeeAmount
      const feeOffset = ((subtotal * this.stripeFeePercent) + this.stripeFeeFixedAmount) / (1 - this.stripeFeePercent)
      return Math.max(0, Math.ceil(feeOffset * 100) / 100)
    },
    donationAmountToCharge() {
      if(!this.DonationAmount) {
        return 0
      }

      return parseFloat(this.DonationAmount) + this.donationStripeFeeOffsetAmount
    },
    donateButtonDisabled() {
      return (this.DonationRecurring && (this.DonationRecurrences === null || this.DonationRecurrences === undefined)) || this.DonationGatewayActive || this.DonationCompleted || !this.DonationAmount || !this.DonationName
    },
    continueButtonLabel() {
      if(!this.DonationAmount) return 'Please enter an amount'
      if(!this.DonationName) return 'Please enter your name'
      if(this.DonationGatewayActive) return 'Processing...'
      if(this.DonationCompleted) return 'Continue'
      if(this.DonationRecurring && (this.DonationRecurrences === null || this.DonationRecurrences === undefined)) return 'Please select recurrences'
      return 'Continue'
    }
  },
  methods: {
    recurrenceLabel(recurrence) {
      if(recurrence === 0) return 'Unlimited'
      return `${recurrence} Months.`
    }
  }
}
